import { useTranslate } from "src/i18n";

export const useProductModalContentTranslate = () => {
  const { t } = useTranslate();

  return {
    article: t("product_modal.article", "Артикул"),
    productId: t("product_modal.product_id", "ID товара"),
    brand: t("product_modal.brand", "Бренд"),
    category: t("product_modal.category", "Категория"),
    soldCount: t("product_modal.sold_count", "Количество продаж"),
    favoriteCount: t("product_modal.favorite_count", "В избранном"),
    gender: t("product_modal.gender", "Пол"),
    source: t("product_modal.source", "Источник"),
    noSubscriptionAlert: t(
      "product_modal.no_subscription_alert",
      "У вас нет подписки или средств, что увидеть данные",
    ),
    buySubscription: t("product_modal.buy_subscription", "Приобрести подписку"),
  };
};
